var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrips(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_2786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9127 31.1242C33.6012 33.3516 31.2334 34.7223 28.6808 34.7223C26.1283 34.7223 23.7693 33.3516 22.449 31.1242C21.1375 28.8878 21.0495 26.1103 22.2377 23.7927C22.2553 23.7747 22.2553 23.7476 22.2818 23.7296L28.0999 14.9553C28.2231 14.7569 28.4344 14.6397 28.6632 14.6397C28.8921 14.6397 29.1121 14.7569 29.2354 14.9553L35.0623 23.7296C35.0623 23.7296 35.0976 23.7747 35.1064 23.7927C36.2946 26.1103 36.2154 28.8878 34.8951 31.1242H34.9127Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1823 25.9747C10.795 17.7234 16.1467 10.0854 24.271 8.05637C33.4867 5.75684 42.7729 11.5372 45.0262 20.9789C47.2796 30.4205 41.6286 39.9343 32.4129 42.2428C27.563 43.4512 22.6954 42.4232 18.8401 39.808",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9355 22.052L11.1472 27.0388L6.27966 22.1331",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_2786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 37,
    fill: "white",
    transform: "translate(5.39941 6.6496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrips);
export default __webpack_public_path__ + "static/media/icon_drips.1dcaff018895b837f3164ba27b8f46b8.svg";
export { ForwardRef as ReactComponent };